// themes/atlantic/index.js
import './index.css';
import { config } from './config';
import { styles } from './styles';
import { TypingIndicator, BackgroundEffects } from './components';

export default {
  config,
  styles,
  components: {
    TypingIndicator,
    BackgroundEffects,
  },
};
